// extracted by mini-css-extract-plugin
module.exports = {"card":"CardImage_card__3gqY-","grid":"CardImage_grid__2_wdx","wrapper":"CardImage_wrapper__37nD0","photo":"CardImage_photo__3JT16","list":"CardImage_list__1Vkeb"};